import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function UserBook({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>UserBook</title>
      <mask id="path-1-inside-1_4304_6024" fill="white">
        <path d="M5 4C5 3.44772 5.44772 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C5.44772 21 5 20.5523 5 20V4Z" />
      </mask>
      <path
        d="M5 4C5 3.44772 5.44772 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C5.44772 21 5 20.5523 5 20V4Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="3"
        mask="url(#path-1-inside-1_4304_6024)"
      />
      <rect
        x="3.40137"
        y="6.375"
        width="2.25"
        height="0.75"
        rx="0.375"
        stroke={color ?? 'currentColor'}
        strokeWidth="0.75"
      />
      <rect
        x="3.375"
        y="11.375"
        width="2.25"
        height="0.75"
        rx="0.375"
        stroke={color ?? 'currentColor'}
        strokeWidth="0.75"
      />
      <rect
        x="3.38965"
        y="16.375"
        width="2.25"
        height="0.75"
        rx="0.375"
        stroke={color ?? 'currentColor'}
        strokeWidth="0.75"
      />
      <path
        d="M8.25 17C8.25 17.4142 8.58579 17.75 9 17.75C9.41421 17.75 9.75 17.4142 9.75 17H8.25ZM16.25 17C16.25 17.4142 16.5858 17.75 17 17.75C17.4142 17.75 17.75 17.4142 17.75 17H16.25ZM9.75 17V16.4118H8.25V17H9.75ZM11.8571 14.2206H14.1429V12.7206H11.8571V14.2206ZM16.25 16.4118V17H17.75V16.4118H16.25ZM14.5357 9.35294C14.5357 10.2589 13.8278 10.9559 13 10.9559V12.4559C14.6969 12.4559 16.0357 11.046 16.0357 9.35294H14.5357ZM13 10.9559C12.1722 10.9559 11.4643 10.2589 11.4643 9.35294H9.96429C9.96429 11.046 11.3031 12.4559 13 12.4559V10.9559ZM11.4643 9.35294C11.4643 8.44702 12.1722 7.75 13 7.75V6.25C11.3031 6.25 9.96429 7.65988 9.96429 9.35294H11.4643ZM13 7.75C13.8278 7.75 14.5357 8.44702 14.5357 9.35294H16.0357C16.0357 7.65988 14.6969 6.25 13 6.25V7.75ZM14.1429 14.2206C15.2863 14.2206 16.25 15.181 16.25 16.4118H17.75C17.75 14.3938 16.1554 12.7206 14.1429 12.7206V14.2206ZM9.75 16.4118C9.75 15.181 10.7137 14.2206 11.8571 14.2206V12.7206C9.84463 12.7206 8.25 14.3938 8.25 16.4118H9.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
